module.exports = __webpack_public_path__ + "img/coming-soon.2f3bcfa0.svg";